import { object } from "prop-types";
import { StoryElement, WithLazy } from "@quintype/components";
import get from "lodash/get";
import React from "react";

import "./hero-video.m.css";

const HeroVideo = ({ story }) => {
  const storyTemplate = get(story, ["story-template"], "");
  const customStyleName = storyTemplate === "video-2" ? "video-2" : "video-1";
  const firstVideo =
    story &&
    story.cards[0]["story-elements"].find(
      ({ type, subtype }) =>
        type === "youtube-video" ||
        (type === "jsembed" && subtype === null) ||
        (type === "jsembed" && subtype === "dailymotion-video")
    );
  return (
    <WithLazy margin="50px">
      {() => (
        <div styleName={`wrapper ${customStyleName}`}>
          <StoryElement element={firstVideo} key={firstVideo.id} story={story} loadIframeOnClick />
        </div>
      )}
    </WithLazy>
  );
};

HeroVideo.propTypes = {
  element: object,
  story: object,
};

export default HeroVideo;
